//线性映射
function mapValue(value, inMin, inMax, outMin, outMax) {
    return (value - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
}

let controller1 = new ScrollMagic.Controller();

// secton1
// let scene1 = new ScrollMagic.Scene({
//         offset: 400,
//         triggerElement: '.team_box1', 
//         triggerHook: "onenter",
//         duration:400
// })
// scene1.on("progress", function (event) {
//     var index=event.progress.toFixed(3) * 100;
//     $('.box1_text div').css({backgroundSize:`${index}% 100%`})
// })

controller1.addScene([]);

$('.box1_btn div').click(function(){
    var index = $(this).index()+1
    $('.box1_btn div').css({background:'transparent',color:'black',border:'1px solid black'})
    $(this).css({background:'red',color:'white',border:'1px solid red'})
    $('.cer_img div').hide()
    $(`.cer_img div:nth-child(${index})`).show()
    $('.box1_content .box1Btn').hide()
    $(`.box1_content .box1Btn:nth-child(${index})`).show()
})